// skip the first segment (webhierarchydraft or localization)
export function getPathWithoutFirstSegment(path: string) {
  const segments = path.split('/');
  return segments.slice(2).join('/');
}
